import Vue from 'vue'

const luTrackedBillPermission = {
  state: {
    luTrackedBillPermissions: [],
    selectedLuTrackedBillPermission: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luTrackedBillPermissions(state) {
      return state.luTrackedBillPermissions
    },
    selectedLuTrackedBillPermission(state) {
      return state.selectedLuTrackedBillPermission
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luTrackedBillPermissions(state, payload) {
      state.luTrackedBillPermissions = payload
    },
    selectedLuTrackedBillPermission(state, payload) {
      state.selectedLuTrackedBillPermission = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuTrackedBillPermission(context, payload) {
      context.commit('selectedLuTrackedBillPermission', payload)
    },
    loadLuTrackedBillPermissions(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuTrackedBillPermission'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luTrackedBillPermissions', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuTrackedBillPermission(context, payload) {
      if (
        context.state.selectedLuTrackedBillPermission &&
        context.state.selectedLuTrackedBillPermission.ID
      ) {
        context.dispatch(
          'loadSelectedLuTrackedBillPermission',
          context.state.selectedLuTrackedBillPermission.ID
        )
      }
    },
    loadSelectedLuTrackedBillPermission(context, payload) {
      if (
        context.state.selectedLuTrackedBillPermission &&
        context.state.selectedLuTrackedBillPermission.ID != payload
      ) {
        context.commit('selectedLuTrackedBillPermission', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuTrackedBillPermission/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuTrackedBillPermission', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuTrackedBillPermissions(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuTrackedBillPermissions')
      })
    },
    updateLuTrackedBillPermission(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuTrackedBillPermission/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill permission updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuTrackedBillPermissions')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuTrackedBillPermission(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuTrackedBillPermission`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill permission created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuTrackedBillPermissions')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuTrackedBillPermission(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuTrackedBillPermission', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuTrackedBillPermission', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuTrackedBillPermission(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuTrackedBillPermission/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill permission deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuTrackedBillPermissions')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luTrackedBillPermission
